import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import LibraryAddCheckOutlinedIcon from '@material-ui/icons/LibraryAddCheckOutlined'
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck'

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { ChevronDownIcon } from 'asterX-UI/Icons'
import { Modal } from 'asterX-UI/Modals'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { useFilterChipStyles } from 'asterX-UI/Inputs/inputs.styles'
import clsx from 'clsx'
import AutoCompleteField from './AutoCompleteField'
import { DatePicker } from '@material-ui/pickers'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const INPUT_TYPE = 'INPUT'
const SELECT_TYPE = 'SELECT'
const AUTOCOMPLETE_TYPE = 'AUTOCOMPLETE'
const MULTI_SELECT_TYPE = 'MULTI_SELECT'
const RANGE_TYPE = 'RANGE'
const RANGE_DATE_TYPE = 'RANGE_DATE'
/**
 * @function FilterChip
 * @param {string} value - value of the input
 * @param {string} label - label of the input
 * @param {string} name - name of the input
 * @param {string} labelKey - key of the label
 * @param {array} labelKeys - keys of the label
 * @param {string} valueKey - key of the value
 * @param {string} textType - type of the text
 * @param {string} type - type of the input { INPUT, SELECT, MULTI_SELECT, RANGE, RANGE_DATE }
 * @param {boolean} hasSelectAll - has selected all option
 * @param {array} options - options of the input
 * @param {function} onRemove - function to remove the input
 * @param {array} rangeLabel - label of the range ['from', 'to']
 * @param {function} onChange - function to change the input
 * @param props
 * @returns {ReactElement}
 *
 */
const FilterChip = ({
  value,
  label,
  name,
  labelKey = '',
  labelKeys = [],
  valueKey = '',
  textType = 'text',
  type = INPUT_TYPE,
  hasSelectAll = false,
  options = [],
  onRemove,
  rangeLabel = ['От', 'До'],
  onChange = e => {},
  ...props
}) => {
  const classes = useFilterChipStyles()

  const [open, setOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState(value)
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const filterOptions = item => {
    if (searchValue) {
      if (labelKeys?.length > 0 || labelKey) {
        return (
          (labelKeys?.length > 0 &&
            concatLabel(item)
              ?.toLowerCase()
              ?.includes(searchValue?.toLowerCase())) ||
          item?.[labelKey]?.toLowerCase()?.includes(searchValue?.toLowerCase())
        )
      }
      return item
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchValue?.toLowerCase())
    }
    return true
  }

  const handleClose = () => {
    setSearchValue('')
    setOpen(false)
  }

  const handleOpen = () => setOpen(true)

  const handleSave = () => {
    onChange({ target: { name, value: selectedValue } })

    handleClose()
  }

  const handleReset = () => {
    const value =
      type === MULTI_SELECT_TYPE
        ? []
        : type === RANGE_TYPE
        ? { min: null, max: null }
        : type === RANGE_DATE_TYPE
        ? { from: null, to: null }
        : ''
    onChange({ target: { name, value: value } })
    handleClose()
  }

  const concatLabel = item => {
    return labelKeys?.reduce((acc, key) => {
      return acc + ' ' + item[key]
    }, '')
  }

  const onChangeRange = e => {
    const { name, value } = e.target

    setSelectedValue(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const onChangeDateRange = name => value => {
    setSelectedValue(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const getValueKey = item => (valueKey ? item?.[valueKey] : item)
  const onSelected = item => () => {
    if (type === MULTI_SELECT_TYPE) {
      if (selectedValue?.includes(getValueKey(item)))
        setSelectedValue(
          selectedValue?.filter(value => value !== getValueKey(item))
        )
      else
        selectedValue?.length === 0
          ? setSelectedValue([getValueKey(item)])
          : setSelectedValue([...selectedValue, getValueKey(item)])
    } else setSelectedValue(getValueKey(item))
  }

  const onSelectAll = () => {
    if (type === MULTI_SELECT_TYPE) {
      if (options.length === selectedValue?.length) return setSelectedValue([])

      setSelectedValue(options.map(item => getValueKey(item)))
    }
  }

  const getSelectedClass = () => {
    if ([INPUT_TYPE, SELECT_TYPE, AUTOCOMPLETE_TYPE].includes(type)) {
      return value ? classes.rootSelected : ''
    }
    if ([MULTI_SELECT_TYPE].includes(type)) {
      return value?.length > 0 ? classes.rootSelected : ''
    }
    if ([RANGE_TYPE, RANGE_DATE_TYPE].includes(type)) {
      return value?.min || value?.max || value?.from || value?.to
        ? classes.rootSelected
        : ''
    }
    return ''
  }
  return (
    <>
      <div
        className={clsx(classes.root, getSelectedClass())}
        onClick={handleOpen}
      >
        {label} <ChevronDownIcon size={'small'} />
      </div>

      <Modal open={open} maxWidth={'sm'} fullWidth>
        <ModalTitle onClose={handleClose}>{label}</ModalTitle>

        <DialogContent>
          <Grid container spacing={2}>
            {INPUT_TYPE === type && (
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  autoFocus
                  label={label}
                  type={textType}
                  value={selectedValue}
                  onChange={e => setSelectedValue(e.target.value)}
                />
              </Grid>
            )}

            {AUTOCOMPLETE_TYPE === type && (
              <Grid item xs={12} md={12}>
                <AutoCompleteField
                  fullWidth
                  name={name}
                  label={'Поиск'}
                  value={selectedValue}
                  options={options}
                  onChange={e => setSelectedValue(e.target.value)}
                />
              </Grid>
            )}

            {[SELECT_TYPE, MULTI_SELECT_TYPE].includes(type) && (
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label={'Поиск'}
                  value={searchValue}
                  onChange={e => setSearchValue(e.target.value)}
                  InputProps={
                    type === MULTI_SELECT_TYPE && hasSelectAll
                      ? {
                          endAdornment: (
                            <InputAdornment position={'start'}>
                              <IconButton onClick={onSelectAll}>
                                {options.length === selectedValue?.length ? (
                                  <LibraryAddCheckIcon color={'primary'} />
                                ) : (
                                  <LibraryAddCheckOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          )
                        }
                      : {}
                  }
                />
              </Grid>
            )}

            {[SELECT_TYPE, MULTI_SELECT_TYPE].includes(type) && (
              <Grid item xs={12} md={12}>
                <List
                  style={{
                    height: 300,
                    overflowY: 'auto'
                  }}
                >
                  {options?.filter(filterOptions)?.map((item, index) => (
                    <ListItem
                      key={`option_${index}`}
                      onClick={onSelected(item)}
                    >
                      <ListItemIcon>
                        <Checkbox
                          color={'primary'}
                          edge="start"
                          checked={
                            type === MULTI_SELECT_TYPE
                              ? selectedValue?.includes(getValueKey(item))
                              : selectedValue === getValueKey(item)
                          }
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>

                      <ListItemText
                        id="switch-list-label-wifi"
                        primary={
                          typeof item === 'boolean'
                            ? item
                              ? 'Да'
                              : 'Нет'
                            : labelKeys?.length > 0
                            ? concatLabel(item)
                            : !!labelKey
                            ? item?.[labelKey]
                            : item
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            )}

            {RANGE_TYPE === type && (
              <Grid
                container
                direction={'row'}
                xs={12}
                md={12}
                justifyContent={'center'}
              >
                <Grid item xs={6}>
                  <TextField
                    label={rangeLabel[0]}
                    type={textType}
                    InputProps={{
                      classes: {
                        root: classes.rangeInputLeft
                      }
                    }}
                    value={selectedValue?.min}
                    name={'min'}
                    onChange={onChangeRange}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label={rangeLabel[1]}
                    type={textType}
                    InputProps={{
                      classes: {
                        root: classes.rangeInputRight
                      }
                    }}
                    value={selectedValue?.max}
                    name={'max'}
                    onChange={onChangeRange}
                    fullWidth
                  />
                </Grid>
              </Grid>
            )}
            {RANGE_DATE_TYPE === type && (
              <Grid
                container
                direction={'row'}
                xs={12}
                md={12}
                justifyContent={'center'}
              >
                <Grid item xs={6}>
                  <DatePicker
                    label={rangeLabel[0]}
                    format="dd.MM.yyyy"
                    InputProps={{
                      classes: {
                        root: classes.rangeInputLeft
                      },
                      endAdornment: (
                        <InputAdornment position={'start'}>
                          <DateIcon
                            style={{
                              color: GRAY_COLORS[500]
                            }}
                          />
                        </InputAdornment>
                      )
                    }}
                    value={selectedValue?.from || null}
                    name={'from'}
                    onChange={onChangeDateRange('from')}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <DatePicker
                    label={rangeLabel[1]}
                    format="dd.MM.yyyy"
                    InputProps={{
                      classes: {
                        root: classes.rangeInputRight
                      },
                      endAdornment: (
                        <InputAdornment position={'start'}>
                          <DateIcon
                            style={{
                              color: GRAY_COLORS[500]
                            }}
                          />
                        </InputAdornment>
                      )
                    }}
                    value={selectedValue?.to || null}
                    name={'to'}
                    onChange={onChangeDateRange('to')}
                    fullWidth
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <Button fullWidth onClick={handleReset}>
                Сбросить
              </Button>
            </Grid>

            <Grid item xs={6} md={6}>
              <Button
                color={'primary'}
                variant={'contained'}
                fullWidth
                onClick={handleSave}
              >
                Применить{' '}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Modal>
    </>
  )
}

export default FilterChip

FilterChip.propTypes = {
  value: PropTypes.string || PropTypes.number || PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  name: PropTypes.string,
  options: PropTypes.array,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string
}
